export default "__VITE_ASSET__DNleVTng__"